// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/ranks.css
// module id = 2405
// module chunks = 2